/**
 * The internal contractors API answers every write, and `GET /:partnerDriverId/steps` for an
 * unknown driver, with a 200 and an EMPTY body. `callApi` would run `response.json()` on that and
 * throw a SyntaxError on a success, so those sagas request the body as text
 * (`returnResponse: true`) and parse it here. Malformed JSON on a 200 is a genuine anomaly and
 * throws, so the saga's `captureSentryError` records it.
 */
export const parseJsonBody = <T>(raw: unknown): T | null => {
  if (raw === null || raw === undefined) {
    return null
  }

  if (typeof raw === 'object') {
    return raw as T
  }

  if (typeof raw !== 'string') {
    return null
  }

  const trimmed = raw.trim()

  if (trimmed === '' || trimmed === 'null') {
    return null
  }

  return JSON.parse(trimmed) as T
}
